import quarantine from '../../config/fight-rig-quarantine.json'

const blockedByClip = new Map(
  Object.entries(quarantine.blockedClips).map(([clip, heroIds]) => [
    clip.toLowerCase(),
    new Set(heroIds),
  ]),
)

export function isRigAnimationClipQuarantined(fighterId:string|undefined,clipName:string){
  if(!fighterId)return false
  const blocked=blockedByClip.get(clipName.trim().toLowerCase())
  return blocked?.has(fighterId)??false
}

export const RIG_QUARANTINED_HERO_IDS = Object.freeze(
  [...new Set(Object.values(quarantine.blockedClips).flat())],
)
